import gql from 'graphql-tag';

export default gql`
  query flightMarket($origin: IataCode!, $destination: IataCode!) {
    flightMarket(origin: $origin, destination: $destination) {
      type
      calendar {
        availableFrom
        availableUntil
        departingDates {
          date
        }
        returningDates {
          date
        }
      }
    }
  }
`;
